<template>
  <div v-if="itemdata.field_specifics"  :class="`row m-0 input ${viewdata} specifics`">
    <div v-for="(spec, spec_index) in itemdata.field_specifics" :key="spec.id" class="col-auto" v-if="spec.locale == locale && spec.name != 'Brand' && spec.name != 'MPN'">
		<label :class="spec.aspectrequired ? 'Required' : ''">
			<div>{{spec.name}} {{spec.locale}}</div>
			<input 
				:key="textkey" 
				v-if="spec.selectionmode != 'SelectionOnly'" 
				type="text" 
				v-model="spec.item_specifics" 
				v-on:change="store($event, spec)" />

			<select v-if="spec.values" v-model="spec.item_specifics" v-on:change="store($event, spec)">
				<option></option>
				<option v-for="(v,i) in spec.values" :key="spec_index + i">{{v}}</option>
			</select>
		</label>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Data from '../../main';
import { global_emits } from '../../main';

// import the styles
export default {
	name: 'Specifics',
	props: {
		item: Array,
		view: String,
	},
	data() {		
		return {
			itemdata: this.item[0],
			viewdata: this.view,
			options: null,
			show: false,
			item_specifics: {},
			locale: 'US',
			textkey: 0
		};
	},

	mounted() {
		
		let that = this;
		global_emits.$on('locale_changed', (emitted) => {
			that.locale = emitted.locale.value;
		});

	},

	methods: {

		store: function( event, spec ) {
			this.$Progress.start();
			
			//console.log(event, spec);
			//return;
			
			this.item[0].field_specifics.forEach(e => {
				if( e.name == spec.name && e.values.includes(event.target.value) )
					e.item_specifics = event.target.value;

				
			});

			// color to colour
			if( spec.name == 'Color' ) {

				this.item[0].field_specifics.find(e => e.name == 'Colour').item_specifics = event.target.value;

			}

			if( spec.name == 'Colour' ) {

				this.item[0].field_specifics.find(e => e.name == 'Color').item_specifics = event.target.value;

			}


			this.textkey += 1;			

			this.$axios
				.post('/specifics', {
					item_id: this.itemdata.id,
					category_id: this.itemdata.category.id,
					specifics: this.itemdata.field_specifics
				})
				.then((response) => {
					return;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},

	},
};

</script>

<style scoped lang="less">
span{
	display:block;

	&:before{
		content:"\2022 ";
	}
	&:not(:first-of-type):before{
		content:"\00BB ";
	}
}

.input > div{
  padding: 0 4px 4px 0;
  position: relative;
  cursor: pointer;
  height: 100%;
}

.full > div{
  border: 1px solid #efefef;
  margin-bottom: 20px;
}
.input > div > p{
  margin: 0;
}
.full > div > p{
  color: grey;
}
</style>

<style lang="less">
	.specifics{
		padding: 4px 0 0 4px;
		
		label{
			padding: 2px;
			border:1px solid #e4e4e4;
			margin:0;
		}
		
		label.Required{
			border:1px solid red;
		}
		
		select, input{
			border-radius: 0;
			border:1px solid #ccc;
			padding: 2px;
			max-width: 100px;;
		}
		input{
			padding-bottom:1px;
		}
		
	}
	
	
</style>

